export function expand() {
    var secondaryDescription = document.querySelector('.site-event-details__secondary-description');
    var readMoreButton = document.querySelector('.site-event-details__read-more');

    if (secondaryDescription && readMoreButton) {
        readMoreButton.addEventListener('click', function () {
            var fullHeight = secondaryDescription.scrollHeight + 1000 + "px";
            secondaryDescription.classList.add('site-event-details__secondary-description--active');
            secondaryDescription.style.maxHeight = fullHeight;
            secondaryDescription.style.transition = 'max-height 0.5s ease-in-out';

            readMoreButton.style.display = 'none';
        });
    }
}